<template lang="pug">
.giftVoucher.data.left(:class="{'new-item': isNew}")
  .data-general-information(@click="expand = !expand")
    .item-list
      .data-number-list(:class="{hidden: isNew}") {{ isNew ? 0 : index + 1 }}
      .data-information-list.giftVoucher
        .data-info
          .data-description-list.capitalize(v-if="!history")
            span {{  data.status }} - {{ data.name }} - {{ data.phone }} - {{ money(data.value) }} - {{ dateTime(data.createdAt) }}
            span.method-pay-container(v-if="data.methodPay")
              img.data-description-list-image(:src="`${imagePath}/methods/light/${data.methodPay}.png`" :alt="data.methodPay")

  transition.data-details-information(name="slide-fade")
    shForm.list(v-if="expand && !history" :dataOriginal="data" :fillData="true")

  .container-actions
    .buttons-actions(v-if="data.status === 'created'")
      shActionButton(:action="approveGiftVoucher" :params="[data.phone]"  text="Aprobar" textRunning="Aprobando")

    .buttons-actions(v-if="data.status === 'approved'")
      shActionButton(:action="disapproveGiftVoucher" :params="[data.phone]"  text="Desaprobar" textRunning="Desaprobando")
      shActionButton(:action="payGiftVoucher" :params="[data.phone]"  text="Pagar" textRunning="Pagando")

    .buttons-actions(v-if="data.status === 'paid'")
      shActionButton(:action="unpayGiftVoucher" :params="[data.phone]"  text="Eliminar Pago" textRunning="EliminandoPago")
      shActionButton(:action="redeemedGiftVoucher" :params="[data.phone]"  text="Redimir Bono" textRunning="Redimiendo el Bono")

    .buttons-actions(v-if="data.status === 'redeemed'")
      shActionButton(:action="unredeemedGiftVoucher" :params="[data.phone]"  text="No Redimido" textRunning="No Redimido")
</template>

<script>
import shForm from './Form'
import shHistory from './History'
import shExpandButton from '@/components/elements/ExpandButton'
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'
import modals from '@my/store/modals'
import gql from '@my/graphql'
import gqlGiftVoucher from '@/graphql/giftVoucher'

export default {
  name: 'GiftVoucher',

  mixins: [mFilters, mForm],

  components: { shForm, shExpandButton, shHistory },

  props: {
    data: Object,
    index: Number,
    isNew: Boolean,
    history: Boolean
  },

  data () {
    return {
      checked: false,
      expand: false
    }
  },

  methods: {
    async approveGiftVoucher (phone) {
      const mutation = gqlGiftVoucher.APPROVE

      if (!phone) return

      const response = await gql.mutate(mutation, { phone })

      if (response) {
        this.$store.commit('updateStatusGift', { phone, status: 'approved' })
        modals.showMessage({ message: `Se aprobó el bono para el número ${phone} correctamente` })
      }
    },

    async disapproveGiftVoucher (phone) {
      const mutation = gqlGiftVoucher.DISAPPROVE

      if (!phone) return

      const response = await gql.mutate(mutation, { phone })

      if (response) {
        this.$store.commit('updateStatusGift', { phone, status: 'created' })
        modals.showMessage({ message: `Se desaprobo el bono para el número ${phone} correctamente` })
      }
    },

    async payGiftVoucher (phone) {
      const mutation = gqlGiftVoucher.PAY

      if (!phone) return

      const response = await gql.mutate(mutation, { phone })

      if (response) {
        this.$store.commit('updateStatusGift', { phone, status: 'paid' })
        modals.showMessage({ message: `Se pagó el bono para el número ${phone} correctamente` })
      }
    },

    async unpayGiftVoucher (phone) {
      const mutation = gqlGiftVoucher.UNPAY

      if (!phone) return

      const response = await gql.mutate(mutation, { phone })

      if (response) {
        this.$store.commit('updateStatusGift', { phone, status: 'approved' })
        modals.showMessage({ message: `Se elimino pago para el bono para el número ${phone} correctamente` })
      }
    },

    async redeemedGiftVoucher (phone) {
      const mutation = gqlGiftVoucher.REDEEMED

      if (!phone) return

      const response = await gql.mutate(mutation, { phone })

      if (response) {
        this.$store.commit('updateStatusGift', { phone, status: 'redeemed' })
        modals.showMessage({ message: `Se redimió el bono para el número ${phone} correctamente` })
      }
    },

    async unredeemedGiftVoucher (phone) {
      const mutation = gqlGiftVoucher.UNREDEEMED

      if (!phone) return

      const response = await gql.mutate(mutation, { phone })

      if (response) {
        this.$store.commit('updateStatusGift', { phone, status: 'paid' })
        modals.showMessage({ message: `Se eliminó el redimidó del bono para el número ${phone} correctamente` })
      }
    }
  },

  beforeDestroy () {
    this.expand = false
  }
}
</script>

<style lang="stylus">
.data-description-list-image-x
  height 10em

.data-description-list.sizes
  display inline-flex

.data-information-list.giftVoucher
  display inline-flex
  gap 1em
  align-items center

.data-title-list.data-giftVoucher
  display flex
  align-items center
  gap .3em

.data-description-list-image-brand
  height 1.2em
  display block

.data-description-list-image
  height 1.2em
</style>



// WEBPACK FOOTER //
// src/components/pages/giftVoucher/GiftVoucher.vue